module.exports = __webpack_public_path__ + "img/trash-white.ba2102b6.svg";